import { type TCreateStructuredLogMessage } from '../types/adscopilot-structured-log-types';
import { createStructuredLogBase } from './create-structured-log-base';

export const createStructuredLogMessage: TCreateStructuredLogMessage = (params) => {
  const { options, ...restParams } = params;
  const { activity } = restParams;

  const structuredLogBase = createStructuredLogBase(restParams);

  const shouldOverrideConversationId = !activity.conversation?.id || activity.value === 'LiveAgentMessage' as any;

  return {
    ...structuredLogBase,
    conversationId: shouldOverrideConversationId ? options!.copilotConversationId as string : activity.conversation!.id as string,
    activityType: 'Message',
    activityId: activity.id,
    replyToId: activity.replyToId,
    siteLinks: activity.value?.SiteLinks,
    learnMoreLinks: activity.value?.Sources,
    questionSuggestions: activity.value?.QuestionSuggestions,
    additionalContext: {
      isHiddenFromUser: activity.value?.isHiddenFromUser,
      liveAgentConversationId: activity.value === 'LiveAgentMessage' ? activity.conversation?.id : undefined,
    },
  };
};
